/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { TOTPVerifyAttestationData } from './TOTPVerifyAttestationData';
import {
    TOTPVerifyAttestationDataFromJSON,
    TOTPVerifyAttestationDataFromJSONTyped,
    TOTPVerifyAttestationDataToJSON,
} from './TOTPVerifyAttestationData';

/**
 * 
 * @export
 * @interface TOTPVerifyAttestation
 */
export interface TOTPVerifyAttestation {
    /**
     * 
     * @type {string}
     * @memberof TOTPVerifyAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof TOTPVerifyAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {TOTPVerifyAttestationData}
     * @memberof TOTPVerifyAttestation
     */
    data?: TOTPVerifyAttestationData;
}

/**
 * Check if a given object implements the TOTPVerifyAttestation interface.
 */
export function instanceOfTOTPVerifyAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function TOTPVerifyAttestationFromJSON(json: any): TOTPVerifyAttestation {
    return TOTPVerifyAttestationFromJSONTyped(json, false);
}

export function TOTPVerifyAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPVerifyAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': !exists(json, 'data') ? undefined : TOTPVerifyAttestationDataFromJSON(json['data']),
    };
}

export function TOTPVerifyAttestationToJSON(value?: TOTPVerifyAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
        'data': TOTPVerifyAttestationDataToJSON(value.data),
    };
}

